import styled from "styled-components";
import themes from "@/styles/themes";
import {mdiAlert, mdiClose} from "@mdi/js";
import Icon from "@mdi/react";
import {SET_MODAL} from "@/store/slices/appSlice";
import {useDispatch, useSelector} from "react-redux";
import Events from "@/utils/Events";
import { useEffect } from "react";
import {GET_OFFER_TYPE} from "@/store/slices/offerSlice";

const Block = styled.div`
  background: white;
  padding: 34px 38px;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0 7px 40px 0 rgba(0, 0, 0, 0.06);
  border: solid 1px #d6d6d6;
  position: relative;
`
const ContentArea = styled.div`
  position: relative;
  width: 270px;
`
const IconDiv = styled.div`
  background: ${themes.red};
  color: ${themes.white};
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
`
const CallAction = styled.p`
  color: ${themes.estadao};
  font-weight: 700;
  line-height: 1.2;
`
const Text = styled.p`
  font-size: 12px;
`
const CloseButton = styled.button`
  background: none;
  border: none;
  color:${themes.grey};
  cursor: pointer;
  position: absolute;
  right: 12px;
  top: 12px;

  svg {
    width: 14px;
    height: 14px;
  }
`

const AnotherOfferButton = styled.a`
  background: ${themes.estadao};
  border: none;
  color: white;
  font-weight: 600;
  font-size: 12px;
  padding: 11.5px 22px;
  display: inline-block;
  margin: 6px 0;
  border-radius: 5px;
  cursor: pointer;
  text-transform: uppercase;
`

const NumberTel = styled.a`
  font-weight: 600;
  color: #000;
  :hover{
    text-decoration: underline;
  }
`

export default function UsuarioAssinante() {
    const offer_type = useSelector(GET_OFFER_TYPE)

  useEffect(()=>{
    events.trigger("pagamento_cartao_assinatura_vigente", { offer_type })
  });

    const dispatch = useDispatch();
    const events = new Events();

    return (
        <Block>
            <CloseButton onClick={() => {
              events.trigger("pagamento_cartao_fechar_assinatura_vigente", { offer_type }),
                dispatch(SET_MODAL({type: null, show: false}))
            }}><Icon path={mdiClose} size={1}></Icon></CloseButton>

            <ContentArea>
                <IconDiv>
                    <Icon path={mdiAlert} size={1}/>
                </IconDiv>
                <CallAction>
                  Você já possui uma assinatura vigente
                </CallAction>
                <Text>
                  Se estiver com dificuldades para acessar nossos conteúdos, saia de sua conta e tente se logar novamente. Ou ligue: 
                </Text>
                <Text>
                  <NumberTel href="tel:4003-5323" onClick={()=>{ events.trigger("modal_assinante_sac_capitais", { offer_type }) }}>4003-5323</NumberTel> - Capitais e Regiões metropolitanas <br />
                  <NumberTel href="tel:0800 014 7720" onClick={()=>{ events.trigger("modal_assinante_sac_demais_localidades", { offer_type }) }}>0800 0147720</NumberTel> - Demais Localidades
                </Text>

                <Text>
                Agora, se deseja fazer uma nova assinatura, <br/>clique abaixo:
                </Text>

                <AnotherOfferButton onClick={() => {
                  events.trigger("pagamento_cartao_fechar_assinatura_vigente", { offer_type }),
                  dispatch(SET_MODAL({type: null, show: false}))
                }}>Seguir com nova assinatura</AnotherOfferButton>
            </ContentArea>
        </Block>
    )
}